export function maskEmail(email) { //ui-cmd-1
    // Split the email into the local part and domain part
    if (email?.length > 0) {

        const [localPart, domainPart] = email?.split('@');

        // Check if the local part is longer than 5 characters
        const maskedLocalPart = localPart.length > 5
            ? localPart.slice(0, 5) + '*'.repeat(5)  // Mask after 5 characters if longer
            : localPart;  // Keep unchanged if the length is exactly 5

        // Recombine the local and domain parts
        return maskedLocalPart + '@' + domainPart;

    }

}

export function maskPhoneNumber(phoneNumber) { //ui-cmd-1
    // Convert phone number to a string in case it's not already
    const phoneStr = phoneNumber?.toString();

    // Check if the phone number has at least 6 digits (2 for the beginning, 4 for the end)
    if (phoneStr?.length > 6) {
        const firstPart = phoneStr.slice(0, 2);  // Extract the first 2 digits
        const lastPart = phoneStr.slice(-4);     // Extract the last 4 digits
        const maskedPart = '*'.repeat(phoneStr.length - 6);  // Mask the remaining middle part

        return firstPart + maskedPart + lastPart;
    }

    // If the phone number is shorter than 6 digits, return it as is
    return phoneStr;
}
export function isNotNullOrUndefined(value) { //ui-cmd-1
    return value !== null && value !== undefined;
}

export const getMinMaxForPhoneCode = (phoneCode) => { //ui-cmd-1
    switch (phoneCode) {
        case '99': // India
            return { min: 10, max: 10 };
        default:
            return { min: 7, max: 15 };
    }
};